// extracted by mini-css-extract-plugin
export default {"title":"EmployeeAttributes_title__edzXp","description":"EmployeeAttributes_description__a3+ES"};